export const RESEARCH_STAGE_MESSAGES = {
  QUEUED: 'Analyzing your question…',
  ANALYZING: 'Analyzing your question…',
  SEARCHING: 'Searching indexed documents…',
  READING: 'Reading relevant sections…',
  GENERATING: 'Generating your response…',
  FINALIZING: 'Finalizing…',
};

/** Resolve display text from requirementsChatbot-polling job record. */
export function resolveResearchProgressMessage(pollData) {
  if (!pollData) return RESEARCH_STAGE_MESSAGES.QUEUED;
  if (pollData.progressMessage) return pollData.progressMessage;
  if (pollData.stage && RESEARCH_STAGE_MESSAGES[pollData.stage]) {
    return RESEARCH_STAGE_MESSAGES[pollData.stage];
  }
  if (pollData.status === 'processing') return RESEARCH_STAGE_MESSAGES.ANALYZING;
  return RESEARCH_STAGE_MESSAGES.QUEUED;
}
